import en from '../translations/en.json';
export default en;



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/locale-data/en.js